import React, { useState, Fragment } from "react";
import { ChevronDownIcon, ChevronUpIcon, MagnifyingGlassIcon, XCircleIcon, CheckCircleIcon, TrashIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import CustomTooltipComponent from "./custom_tooltip_component";
import { useLocation } from "wouter";



export default function BpCuTableEmployee ({ type, documents, onDelete, onPreview }) {
    const [openId, setOpenId] = useState(null);
    const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));   
    const [, setLocation] = useLocation();
    
    const emptyMsg =
        type === "bp" ? "Nessuna busta paga caricata" : "Nessuna certificazione unica caricata";

    const goToGeneralList = (d) => {
    if (type === "bp") {
        const year = d.year ?? d.anno;
        const month = d.month ?? d.mese;

        // fallback: se non hai i campi, non puoi aprire “al mese giusto”
        const qs = new URLSearchParams();
        if (year) qs.set("year", String(year));
        if (month) qs.set("month", String(month));
        qs.set("focus", "1"); // flag per scroll/focus

        setLocation(`/buste?${qs.toString()}`);
        return;
    }

    // CU
    const year = d.year ?? d.anno;
    const qs = new URLSearchParams();
    if (year) qs.set("year", String(year));
    qs.set("focus", "1");

    setLocation(`/cu?${qs.toString()}`);
    };

    return (
        <table className="min-w-full">
            <thead className="border-b border-gray-200">
                <tr className="bg-white text-sm font-semibold text-gray-900 pt-2">
                    <th className="py-2 text-left" />
                    <th className="py-2 text-left">{type === "bp" ? "Mese / Anno" : "Anno"}</th>
                    <th className="py-2 text-left">Caricata</th>
                    <th className="py-2 text-left">Aperta</th>
                    <th className="py-2 text-left" />
                </tr>
            </thead>

            <tbody className="bg-white">
                {documents.length === 0 && (
                <tr>
                    <td colSpan={5} className="py-6 text-center text-sm text-gray-500 italic">
                        {emptyMsg}
                    </td>
                </tr>
                )}
            
                {documents.map((d) => {
                    const isConfirmed =
                        typeof d.isConfirmed === "boolean"
                        ? d.isConfirmed
                        : typeof d.is_confirmed === "boolean"
                            ? d.is_confirmed
                            : !!d.confirmed_at;

                    const rowNeedsConfirm = !isConfirmed;

                    return (
                        <Fragment key={d.id}>
                            <tr
                                className="border-t cursor-pointer hover:bg-gray-100"
                                onClick={() => toggle(d.id)}
                            >
                                <td className="py-3 w-8 px-2">
                                    {openId === d.id ? (
                                        <ChevronUpIcon className="w-5 h-5" />
                                    ) : (
                                        <ChevronDownIcon className="w-5 h-5" />
                                    )}
                                </td>

                                <td className="py-3 text-sm font-medium">{d.title}</td>

                                <td className="py-3 text-sm">
                                    {moment(d.createdAt).format("DD/MM/YYYY HH:mm")}
                                </td>

                                <td className="py-3 align-middle text-sm">
                                    {rowNeedsConfirm ? (
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation(); // non aprire/chiudere la riga
                                                goToGeneralList(d);
                                            }}
                                            className="inline-flex items-center border border-red-500 rounded-md bg-red-50 text-red-700 px-2 py-1 text-xs font-semibold hover:bg-red-100"
                                            title="Vai alla lista generale"
                                        >
                                            DA CONFERMARE
                                        </button>
                                    ) : d.isRead ? (
                                        <div className="inline-flex items-center gap-1">
                                            <CheckCircleIcon className="h-4 w-4 text-green-500" />
                                            {moment(d.readAt).format("DD/MM/YYYY HH:mm")}
                                        </div>
                                    ) : (
                                        <div className="inline-flex items-center gap-1">
                                            <XCircleIcon className="h-4 w-4 text-red-500" />
                                            <span className="text-red-500">Non letta</span>
                                        </div>
                                    )}
                                </td>


                                <td className="py-3 pr-3">
                                    {/* wrapper che rimane in linea */}
                                    <div className="flex items-center justify-center gap-2">
                                        <CustomTooltipComponent title="Apri anteprima">
                                            <button
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                onPreview({ url: d.download, name: d.title, description: d.description })
                                                }}
                                                className="inline-flex items-center text-indigo-600 hover:text-indigo-800"
                                            >
                                                <MagnifyingGlassIcon className="h-5 w-5" />
                                            </button>
                                        </CustomTooltipComponent>

                                        <CustomTooltipComponent title="Elimina">
                                            <button
                                                onClick={(e) => { e.stopPropagation(); onDelete(d.id); }}
                                                className="inline-flex items-center text-gray-700 hover:text-red-600"
                                            >
                                                <TrashIcon className="h-5 w-5" />
                                            </button>
                                        </CustomTooltipComponent>
                                    </div>
                                </td>
                            </tr>

                            {/* ── RIGA DETTAGLIO ─────────────────────────────────────── */}
                            {openId === d.id && (
                                <tr className="bg-gray-100 shadow-lg">
                                    <td colSpan={5} className="px-6 py-4 text-sm">
                                        <dl className="grid grid-cols-12 gap-y-1 text-sm items-center">
                                            <dt className="col-span-3 font-semibold">File</dt>
                                            <dd className="col-span-9">
                                                <button
                                                    onClick={() =>
                                                    onPreview({
                                                        url: d.download_link || d.download,
                                                        name: d.title,
                                                        description: d.description,
                                                    })
                                                    }
                                                    className="inline-flex items-center gap-1 text-indigo-600 hover:underline"
                                                >
                                                    <MagnifyingGlassIcon className="h-4 w-4" />
                                                    Apri anteprima
                                                </button>
                                            </dd>

                                            {/* Caricato */}
                                            <dt className="col-span-3 font-semibold">Caricato</dt>
                                            <dd className="col-span-9">
                                                {moment(d.createdAt).format("DD/MM/YYYY HH:mm")}
                                            </dd>

                                            {/* Letto */}
                                            <dt className="col-span-3 font-semibold">Letto</dt>
                                            <dd className="col-span-9">
                                                {d.isRead ? moment(d.readAt).format("DD/MM/YYYY HH:mm") : "—"}
                                            </dd>

                                            {/* Descrizione (se presente) */}
                                            {d.description && (
                                            <>
                                                <dt className="col-span-3 font-semibold">Descrizione</dt>
                                                <dd className="col-span-9">{d.description}</dd>
                                            </>
                                            )}
                                        </dl>
                                    </td>
                                </tr>
                            )}
                        </Fragment>
                    );
                })}
            </tbody>
        </table>
    );
}